import React, { useContext } from "react";
import { useLoaderData } from "react-router-dom";

import { QuizContext } from "../../layouts/Main";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import "./Statistics.css";

const Statistics = () => {
  const quizz = useContext(QuizContext);
  return (
    <div className="bg-green-50">
      <h2 className="text-center text-2xl font-bold bg-slate-900 text-white px-6 py-2 relative top-4 w-40 mx-auto rounded-lg statistic ">
        Statistics
      </h2>
      <div className="mt-12 ">
        <ResponsiveContainer width="85%" height={400}>
          <LineChart height={500} width={600} data={quizz.data}>
            <CartesianGrid strokeDasharray="33" />
            <XAxis dataKey="name" height={60} />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="total" stroke="tomato" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default Statistics;
